import { CircularProgress, Grid, List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DistroBasic, DistroPlus } from 'components/DistroLabels';
import { distributionInfo } from 'services/api/stripe/stripeApi';
import FeatureListItem from './components/FeatureListItem';
import {
  StyledContainer,
  StyledLoadingContainer,
  StyledGridItem,
  StyledSubtext,
} from './styled';

const FeaturesContainer = () => {
  const { t } = useTranslation();
  const { data, isLoading } = distributionInfo.useGetDistributionInfoQuery();

  if (isLoading || !data) {
    return (
      <StyledLoadingContainer>
        <CircularProgress />
      </StyledLoadingContainer>
    );
  }

  const { distroPlus, distroBasic } = data;
  const { features: distroPlusFeatures } = distroPlus;
  const { features: distroBasicFeatures } = distroBasic;

  return (
    <StyledContainer>
      <List disablePadding>
        <Grid container>
          <StyledGridItem itemOrder={2}>
            <DistroBasic />
            <StyledSubtext>
              {t('distribution:distributionInfoBlock:distroBasicSubtext')}
            </StyledSubtext>
            <FeatureListItem features={distroBasicFeatures} />
          </StyledGridItem>
          <StyledGridItem itemOrder={1}>
            <DistroPlus />
            <StyledSubtext>
              {t('distribution:distributionInfoBlock:distroPlusSubtext')}
            </StyledSubtext>
            <FeatureListItem features={distroPlusFeatures} />
          </StyledGridItem>
        </Grid>
      </List>
    </StyledContainer>
  );
};

export default FeaturesContainer;
